import { Component, input, output } from '@angular/core';
import { RepairProgressBuckets } from '../../../model/job.model';
import { MatDivider } from '@angular/material/divider';
import { JobCardComponent } from './job-card/job-card.component';

@Component({
  selector: 'app-repair-progress',
  templateUrl: './repair-progress.component.html',
  styleUrls: ['./repair-progress.component.scss'],
  imports: [MatDivider, JobCardComponent]
})
export class RepairProgressComponent {
  buckets = input.required<RepairProgressBuckets>();
  updateBuckets = output<boolean>();
}
